<template>
  <v-off-canvas
    id="client-filters-offcanvas"
    :backdrop-static="false"
    offcanvas-class="offcanvas-end"
    @closed="$emit('closed')"
  >
    <resizable-container>
    <off-canvas-header>
      <h5 class="offcanvas-title">{{ $t('general.shared.filters') }}</h5>
    </off-canvas-header>

    <off-canvas-body>
      <v-form
        id="client-filter-status-select"
        :label="this.$t('general.shared.status')"
        form-type="outline"
      >
        <v-select
          v-model="filterStatus"
          :clearable="false"
          :options="statusTypesOptions"
          :reduce="returnValue => returnValue.key"
          @option:selected="$emit('update:status', filterStatus); $emit('selected')"
        >
          <template v-slot:no-options>
            <div class="my-4">{{ $t('general.vueSelect.noOptions') }}</div>
          </template>
        </v-select>
      </v-form>

      <v-form
        id="client-filter-source-select"
        :label="this.$t('general.shared.source')"
        form-type="outline"
      >
        <v-select
          v-model="filterSource"
          :clearable="false"
          :options="sourceTypes"
          :reduce="returnValue => returnValue.key"
          @option:selected="$emit('update:source', filterSource); $emit('selected')"
        >
          <template v-slot:no-options>
            <div class="my-4">{{ $t('general.vueSelect.noOptions') }}</div>
          </template>
        </v-select>
      </v-form>
    </off-canvas-body>
    </resizable-container> 
  </v-off-canvas>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import vSelect from 'vue-select';
import { VForm } from '@uniqoders/form';
import VOffCanvas from '@/components/vendor/basic/offcanvas/VOffCanvas.vue';
import OffCanvasHeader from '@/components/vendor/basic/offcanvas/OffCanvasHeader.vue';
import OffCanvasBody from '@/components/vendor/basic/offcanvas/OffCanvasBody.vue';
import { mapConcepts } from '@/helpers/ConceptHelper';
import useConcepts from '@/helpers/Concepts';
import ResizableContainer from '@/components/resizablecontainer/ResizableContainer.vue';

export default defineComponent({
  name: 'TheClientFiltersOffcanvas',
  components: {
    OffCanvasBody,
    OffCanvasHeader,
    VOffCanvas,
    vSelect,
    VForm,
    ResizableContainer,
  },
  emits: [
    'closed',
    'selected',
    'update:status',
    'update:source',
  ],
  props: {
    status: {
      type: String,
      required: false,
      default: 'active',
    },
    source: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    return {
      ...useConcepts(),
    };
  },
  data() {
    return {
      filterStatus: this.status,
      filterSource: this.source,
    };
  },
  computed: {
    statusTypesOptions(): any {
      if (!!this.concepts && this.concepts['app.states']) {
        return mapConcepts(this.concepts['app.states']);
      }

      return [];
    },
    sourceTypes(): any {
      if (!!this.concepts && this.concepts['client.source_type']) {
        const sourceTypes = mapConcepts(this.concepts['client.source_type']);

        sourceTypes.unshift({
          key: '',
          label: this.$t('general.shared.all'),
          permission: null,
          value: null,
          order: 0,
          status: 'active',
          icon: '',
          color: '',
        });

        return sourceTypes;
      }

      return [];
    },
  },
  watch: {
    status(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.filterStatus = this.status;
      }
    },
    source(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.filterSource = this.source;
      }
    },
  },
});
</script>
